// Utility functions for formatting values based on field types

const parseDeadlineValue = (value) => {
    if (!value) return { due: '', done: '' };

    if (typeof value === 'object') {
        return {
            due: value.due || value.date || value.value || '',
            done: value.done || ''
        };
    }

    const raw = String(value).trim();
    if (!raw) return { due: '', done: '' };

    try {
        const parsed = JSON.parse(raw);
        const parsedValue = Array.isArray(parsed) ? parsed[0] : parsed;
        if (parsedValue && typeof parsedValue === 'object') {
            return parseDeadlineValue(parsedValue);
        }
    } catch {
    }

    return { due: raw, done: '' };
};

const formatDateValue = (value) => {
    if (!value) return '';

    try {
        if (typeof value === 'string') {
            const dateMatch = value.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
            if (dateMatch) {
                const year = dateMatch[1];
                const month = parseInt(dateMatch[2]);
                const day = parseInt(dateMatch[3]);
                return `${month}/${day}/${year}`;
            }

            const usDateMatch = value.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/);
            if (usDateMatch) return value;
        }

        const dateValue = new Date(value);
        if (isNaN(dateValue.getTime())) return value;
        return dateValue.toLocaleDateString('en-US', {
            month: 'numeric',
            day: 'numeric',
            year: 'numeric'
        });
    } catch {
        return value;
    }
};

export const formatValueByType = (value, typeId) => {
    if (value === null || value === undefined || value === '') {
        return '-';
    }

    switch (typeId) {
        case 1: // Text - Single Line
        case 2: // Text - Multi Line
            return value;
            
        case 3: // Amount - Currency
            const currencyValue = parseFloat(value);
            if (isNaN(currencyValue)) return value;
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(currencyValue);
            
        case 4: // Amount - Percent
            const percentValue = parseFloat(value);
            if (isNaN(percentValue)) return value;
            return `${percentValue}%`;
            
        case 5: // Amount - Number
            const numberValue = parseFloat(value);
            if (isNaN(numberValue)) return value;
            return new Intl.NumberFormat('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(numberValue);
            
        case 6: // Date
            return formatDateValue(value);
            
        case 7: // Time
            try {
                // Assume time is in HH:MM format or HH:MM:SS
                const timeMatch = value.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?$/);
                if (!timeMatch) return value;
                
                let hours = parseInt(timeMatch[1]);
                const minutes = timeMatch[2];
                const ampm = hours >= 12 ? 'PM' : 'AM';
                
                if (hours === 0) hours = 12;
                else if (hours > 12) hours -= 12;
                
                return `${hours}:${minutes} ${ampm}`;
            } catch (error) {
                return value;
            }

        case 20: { // Deadline
            const deadlineValue = parseDeadlineValue(value);
            const dueDate = formatDateValue(deadlineValue.due);
            const doneDate = formatDateValue(deadlineValue.done);
            const displayParts = [];

            if (dueDate) displayParts.push(doneDate ? `Due: ${dueDate}` : dueDate);
            if (doneDate) displayParts.push(`Done: ${doneDate}`);

            return displayParts.length > 0 ? displayParts.join(' • ') : '-';
        }
            
        default:
            return value;
    }
};